import { useMutation } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import {
    createRegisterCompanyRequest,
    createRegisterProviderRequest,
    createRegisterUserRequest,
    updateRegisterKnowPlatformRequest,
    validateRegisterClientCesuRequest,
    validateRegisterClientInformationsRequest,
    validateRegisterProviderInformationsRequest,
    validateRegisterProviderInformationsProfileRequest,
    validateRegisterProviderCesuRequest,
    validateRegisterProviderIbanRequest,
    trackRegisterProviderProgressRequest,
    validateRegisterStepRequest,
} from "lib/api/register";

export const validateRegisterStep = (stepName: string, data: HashMap<unknown>) =>
    parseResponse<unknown>(validateRegisterStepRequest(stepName, data));

export const createRegisterCompany = (data: HashMap<unknown>) =>
    parseResponse<unknown>(createRegisterCompanyRequest(data));

export const updateRegisterKnowPlatform = (id: string, data: HashMap<unknown>) =>
    parseResponse<unknown>(updateRegisterKnowPlatformRequest(id, data));

export const createRegisterUser = (data: HashMap<unknown>) =>
    parseResponse<unknown>(createRegisterUserRequest(data));

export const validateRegisterClientInformations = (data: HashMap<unknown>) =>
    parseResponse<unknown>(validateRegisterClientInformationsRequest(data));

export const validateRegisterClientCesu = (data: HashMap<unknown>) =>
    parseResponse<unknown>(validateRegisterClientCesuRequest(data));

export const createRegisterProvider = (data: HashMap<unknown>) =>
    parseResponse<unknown>(createRegisterProviderRequest(data));

export const validateRegisterProviderInformations = (data: HashMap<unknown>) =>
    parseResponse<unknown>(validateRegisterProviderInformationsRequest(data));

export const validateRegisterProviderInformationsProfile = (data: HashMap<unknown>) =>
    parseResponse<unknown>(validateRegisterProviderInformationsProfileRequest(data));

export const validateRegisterProviderCesu = (data: HashMap<unknown>) =>
    parseResponse<unknown>(validateRegisterProviderCesuRequest(data));

export const validateRegisterProviderIban = (data: HashMap<unknown>) =>
    parseResponse<unknown>(validateRegisterProviderIbanRequest(data));

export const trackRegisterProviderProgress = (data: HashMap<unknown>) =>
    parseResponse<unknown>(trackRegisterProviderProgressRequest(data));

export const useValidateRegisterStep = () =>
    useMutation({
        mutationFn: ({ stepName, data }: { stepName: string; data: HashMap<unknown> }) =>
            validateRegisterStep(stepName, data),
    });

export const useCreateRegisterCompany = () =>
    useMutation({
        mutationFn: (data: HashMap<unknown>) => createRegisterCompany(data),
    });

export const useUpdateRegisterKnowPlatform = () =>
    useMutation({
        mutationFn: ({ id, data }: { id: string; data: HashMap<unknown> }) =>
            updateRegisterKnowPlatform(id, data),
    });

export const useCreateRegisterUser = () =>
    useMutation({
        mutationFn: (data: HashMap<unknown>) => createRegisterUser(data),
    });

export const useValidateRegisterClientInformations = () =>
    useMutation({
        mutationFn: (data: HashMap<unknown>) => validateRegisterClientInformations(data),
    });

export const useValidateRegisterClientCesu = () =>
    useMutation({
        mutationFn: (data: HashMap<unknown>) => validateRegisterClientCesu(data),
    });

export const useCreateRegisterProvider = () =>
    useMutation({
        mutationFn: (data: HashMap<unknown>) => createRegisterProvider(data),
    });

export const useValidateRegisterProviderInformations = () =>
    useMutation({
        mutationFn: (data: HashMap<unknown>) => validateRegisterProviderInformations(data),
    });

export const useValidateRegisterProviderInformationsProfile = () =>
    useMutation({
        mutationFn: (data: HashMap<unknown>) => validateRegisterProviderInformationsProfile(data),
    });

export const useValidateRegisterProviderCesu = () =>
    useMutation({
        mutationFn: (data: HashMap<unknown>) => validateRegisterProviderCesu(data),
    });

export const useValidateRegisterProviderIban = () =>
    useMutation({
        mutationFn: (data: HashMap<unknown>) => validateRegisterProviderIban(data),
    });